(function(){
	'use strict';
	angular.module('app.leanProjects')
		.service('taskFormService', taskFormService);
	
	taskFormService.$inject = ['$http', 'hostUrl', 'leanFilterService'];
	function taskFormService($http, hostUrl, leanFilterService) {
		return {
			getTask: getTask,
			createTask: createTask,
			updateTask: updateTask,
			updateTasks: updateTasks,
			deleteTask: deleteTask
		};
				
		function getTask(taskNdx, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Task/' + taskNdx;
			return $http.get(url)
				.then(getTaskSuccess)
				.catch(getTaskFailed);

			function getTaskSuccess(response) {
				return response;
			}

			function getTaskFailed(error) {
				return error;
			}
		}
		
		function createTask(task, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Task';
			return $http.post(url, task)
				.then(createTaskSuccess)
				.catch(createTaskFailed);
			
			function createTaskSuccess(response) {
				return 'Task created successfully';
			}
			
			function createTaskFailed(error) {
				if(error.status == 403){
					return '';
				}
				return 'Unknown server error';
			}
		}
		
		function updateTask(task, projectNdx, leanDirFactoryNdx, lastModified) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Task/' + task.ndx;
			return $http.put(url, task, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateTaskSuccess)
				.catch(updateTaskFailed);
			
			function updateTaskSuccess(response) {
				return 'Task updated successfully';
			}
			
			function updateTaskFailed(error) {
				if(error.status == 403){
					return '';
				}
				else if(error.status == 412){
					return error.data.error;
				}
				else if (error && error.data && error.data.error) {
					return error.data.error;
				}
				return 'Unknown server error';
			}
		}

		function updateTasks(tasks, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Tasks/BulkDates';
			return $http.put(url, tasks)
				.then(updateTasksSuccess)
				.catch(updateTasksFailed);
			
			function updateTasksSuccess(response) {
				return 'Tasks updated successfully';
			}
			
			function updateTasksFailed(error) {
				if(error.status == 403){
					return '';
				}
				else if(error.status == 412){
					return error.data.error;
				}
				else if (error && error.data && error.data.error) {
					return error.data.error;
				}
				return 'Unknown server error';
			}
		}
		
		function deleteTask(taskNdx, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Task/' + taskNdx;
			return $http.delete(url)
				.then(deleteTaskSuccess)
				.catch(deleteTaskFailed);
			
			function deleteTaskSuccess(response) {
				return 'Task deleted successfully';
			}
			
			function deleteTaskFailed(error) {
				return 'Unknown server error';
			}
		}
	}
})();